if (jQuery('.header-megamenu').length) {
    const megamenu = document.querySelector('.header-megamenu');

    new MutationObserver(function() {
        if (megamenu.classList.contains('active')) {
            jQuery('.header-content').css('opacity','0');            
        } else {
            jQuery('.header-content').css('opacity','1');
        }
    }).observe(megamenu, {
        attributes: true,
        attributeFilter: ['class']
    });
}

if(jQuery('.header-content').length) {
    const header = document.querySelector('.header-content');
    new MutationObserver(function () {
        if(header.classList.contains('fixed')) {
            jQuery('.header-megamenu').css('top','45px');
            jQuery('.header-megamenu-left').css('border-radius', '25px');
        } else {
            jQuery('.header-megamenu').css('top','0');
            jQuery('.header-megamenu-left').css('border-radius', '0 0 25px 25px');
        }
    }).observe(header, {
        attributes: true,
        attributeFilter: ['class']
    });
}

// Fechar megamenu
if (jQuery('.header-megamenu').length) {

    jQuery(document).on('click', function(e) {

        if (
            jQuery('.header-megamenu').hasClass('active') &&
            !jQuery(e.target).closest('.header-megamenu-left').length &&
            !jQuery(e.target).closest('.open-menu').length
        ) {
            jQuery('.header-megamenu').removeClass('active');
        }

    });

}

new Swiper('.main-home-banner-swiper', {
    slidesPerView: 1,
    loop: true,

    // navigation: {
    //     prevEl: '.swiper-arrows-button-prev',
    //     nextEl: '.swiper-arrows-button-next',
    // },

    pagination: {
        el: '.swiper-pagination',
        clickable: true,
    },


    on: {
        init: function () {
            updateHomeBannerColor(this);
        },

        slideChange: function () {
            updateHomeBannerColor(this);
        }
    }
});

function updateHomeBannerColor(swiper) {
    const slide = swiper.slides[swiper.activeIndex];
    const color = jQuery(slide).attr('data-color') || '#fff';

    jQuery('.main-home-banner .swiper-arrows').css('color', color);
    jQuery('.main-home-banner .swiper-pagination-bullet').css('color', color);
}

new Swiper('.swiper-megamenu-ambients', {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 10,

    breakpoints: {
        576: {
            slidesPerView: 3,
        },
        768: {
            slidesPerView: 2,
        },
        1024: {
            slidesPerView: 3,
        },
        1200: {
            slidesPerView: 5,
        }
    }
});

new Swiper('.swiper-home-environments', {
    // loop: true,
    slidesPerView: 1,
    spaceBetween: 15,

    navigation: {
        nextEl: '.swiper-home-environments-next',
        prevEl: '.swiper-home-environments-prev',
    },
    breakpoints: {
        576: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 3,
        },
        1024: {
            slidesPerView: 4,
        },
        1200: {
            slidesPerView: 5,
        }
    }
});

let productsFilterSwiper;

function initProductsFilterSwiper() {

    if (productsFilterSwiper) {
        productsFilterSwiper.destroy(true, true);
    }

    if (!jQuery('.swiper-products-filter').length) {
        return;
    }

    productsFilterSwiper = new Swiper('.swiper-products-filter', {
        loop: true,
        slidesPerView: 1,
        spaceBetween: 10,

        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            },
            1200: {
                slidesPerView: 6,
            }
        }
    });

}

if (jQuery('.swiper-products-filter').length) {
    initProductsFilterSwiper();

    jQuery(document).ajaxComplete(function () {
        initProductsFilterSwiper();
    });
}
if (jQuery('#clear-products-filters').length) {
    jQuery(document).on('click', '#clear-products-filters', function(e) {
        e.preventDefault();

        const url = new URL(window.location.href);
        const order = url.searchParams.get('order') || 'featured';
        const list = jQuery('.main-produtos-content-center-list-content-data');
        const loader = jQuery('.main-produtos-content-center-list-content-data');

        loader.addClass('load');

        jQuery.ajax({
            url: ajax_url,
            type: 'GET',
            data: {
                action: 'clear_products_filters',
                order: order
            },
            success: function(response) {
                if (response.success) {
                    list.replaceWith(response.data.html);

                    jQuery('.list-container input[type="checkbox"]').prop('checked', false);
                    jQuery('.main-produtos-content-center-filter-content a[data-area]').removeClass('active');
                    jQuery('.main-produtos-content-center-list-content-sidebar-actives').empty();
                    jQuery('.main-produtos-content-center-list-content-sidebar .area').val('');

                    url.search = '';
                    if (order !== 'featured') {
                        url.searchParams.set('order', order);
                    }
                    window.history.pushState({}, '', url);

                    jQuery('#clear-products-filters').removeClass('enabled').addClass('disabled');
                }
            },
            complete: function() {
                jQuery('.main-produtos-content-center-list-content-data').removeClass('load');
            }
        });
    });
}
// if (jQuery('.active-filter').length) {
//     jQuery(document).on('click', '.active-filter', function() {
//         const section = jQuery('.main-produtos-content-center');

//         if (section.length) {
//             sessionStorage.setItem('products-scroll', section.offset().top);
//         }
//     });

//     if (sessionStorage.getItem('products-scroll')) {
//         const scrollTop = sessionStorage.getItem('products-scroll');

//         jQuery(window).on('load', function() {
//             jQuery('html, body').scrollTop(scrollTop);
//             sessionStorage.removeItem('products-scroll');
//         });
//     }
// }

if (jQuery('.list-container').length) {

    jQuery(document).on('click', '.list-container input[type="checkbox"]', function() {
        const scrollTop = window.scrollY;

        window.scrollTo(0, scrollTop);

        jQuery(document).one('ajaxComplete', function() {
            window.scrollTo(0, scrollTop);
        });

    });

}

let swiperDownloadsMateriaisFilter;

function initDownloadsMateriaisFilter() {
    if (swiperDownloadsMateriaisFilter) {
        swiperDownloadsMateriaisFilter.destroy(true, true);
    }

    if (!jQuery('.swiper-downloads-materiais').length) {
        return;
    }

    swiperDownloadsMateriaisFilter = new Swiper('.swiper-downloads-materiais', {
        // loop: true,
        slidesPerView: 1,
        spaceBetween: 10,

        breakpoints: {
            576: {
                slidesPerView: 2,
            },
            768: {
                slidesPerView: 3,
            },
            1024: {
                slidesPerView: 4,
            },
            1200: {
                slidesPerView: 5,
            }
        }
    });

}

if (jQuery('.swiper-downloads-materiais').length) {
    initDownloadsMateriaisFilter();

    jQuery(document).ajaxComplete(function () {
        initDownloadsMateriaisFilter();
    });
}

new Swiper('.swiper-categorias-where-find', {
    // loop: true,
    slidesPerView: 1,
    spaceBetween: 10,

    breakpoints: {
        576: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 2,
        },
        1023: {
            slidesPerView: 3,
        },
        1200: {
            slidesPerView: 3,
        }
    }
});

new Swiper('.swiper-home-products', {
    slidesPerView: 2,
    spaceBetween: 15,
    rewind: true,

    navigation: {
        nextEl: '.swiper-home-search-pagination-next',
        prevEl: '.swiper-home-search-pagination-prev',
    },
    pagination: {
        el: '.swiper-home-products-pagination',
        type: 'progressbar',
    },
    breakpoints: {
        576: {
            slidesPerView: 3,
        },
        768: {
            slidesPerView: 4,
        },
        1024: {
            slidesPerView: 5,
        },
        1200: {
            slidesPerView: 6,
        }
    },
    
});


new Swiper('.swiper-product-gallery', {
    slidesPerView: 2,
    spaceBetween: 15,

    breakpoints: {
        596: {
            slidesPerView: 3,
        }
    }
});


new Swiper('.swiper-product-colors', {
    slidesPerView: 'auto',
    spaceBetween: 10
});

new Swiper('.swiper-product-dimensions', {
    slidesPerView: 1,
    spaceBetween: 15,

    breakpoints: {
        576: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 3,
        },
        1024: {
            slidesPerView: 4,
        }
    }
});

new Swiper('.swiper-products-combine', {
    slidesPerView: 1,
    spaceBetween: 15,
    rewind: true,

    navigation: {
        nextEl: '.swiper-produtos-interna-combine-arrows-next',
        prevEl: '.swiper-produtos-interna-combine-arrows-prev',
    },
    pagination: {
        el: '.swiper-products-combine-pagination',
        type: 'progressbar',
    },
    breakpoints: {
        576: {
            slidesPerView: 2,
        },
        768: {
            slidesPerView: 3,
        },
        1024: {
            slidesPerView: 5,
        },
        1200: {
            slidesPerView: 6,
        }
    }
});

const swiperBannersBlog = new Swiper('.swiper-banners-blog', {
    slidesPerView: 1,
    spaceBetween: 50,
    loop: true,
    autoplay: false
});

// Alterar a imagem principal na single de produtos

if(jQuery('.main-produtos-interna-product-infos-gallery').length){
    jQuery(document).on("click", ".main-produtos-interna-product-infos-gallery a", function (e) {
        e.preventDefault();
        const image = jQuery(this).data("image");

        jQuery(".main-produtos-interna-content-infos-gallery-zoom").prop("src", image);
        jQuery(".main-produtos-interna-content-infos-gallery-image .infos-gallery-thumbs-item").data("src", image).data("index", jQuery(this).parent().index());

        return false;
    });

    jQuery(document).on("click", ".main-produtos-interna-product-infos-gallery a", function (ev) {
        ev.preventDefault();

        console.log(jQuery(this).data("image"));
    });
}

 
let swiperSearchCategories;

function initSwiperSearchCategories() {

    if (!jQuery('.swiper-search-categories').length) {
        return;
    }

    if (swiperSearchCategories) {
        console.log(
        document.querySelector('.swiper-search-categories .swiper-wrapper')
        );
        swiperSearchCategories.destroy(true, false);
        console.log(
        document.querySelector('.swiper-search-categories .swiper-wrapper')
        );
    }

    swiperSearchCategories = new Swiper('.swiper-search-categories', {
        slidesPerView: 2,
        spaceBetween: 10,
        loop: false,

        breakpoints: {
            576: {
                slidesPerView: 3,
            },
            768: {
                slidesPerView: 4,
            },
            1024: {
                slidesPerView: 4,
            }
        }
    });
}

initSwiperSearchCategories();

jQuery(document).ajaxComplete(function () {
    initSwiperSearchCategories();
});

if (jQuery('.main-blog-list-categories-items').length) {
jQuery(document)
    .off('click.blogAjax', '.main-blog-list-categories-items a')
    .on('click.blogAjax', '.main-blog-list-categories-items a', function (e) {

        e.preventDefault();

        var t = jQuery(this);

        jQuery.ajax({
            url: t.attr('href'),

            beforeSend: function () {
                jQuery('.loader').addClass('active');
            },

            success: function (n) {

                jQuery('.main-blog-list-categories-items a').removeClass('active');
                t.addClass('active');

                jQuery('.main-blog-list-cards').html(
                    jQuery(n).find('.main-blog-list-cards').html()
                );

                jQuery('.loader').removeClass('active');
            }
        });

    });
}
// Remover fancybox da tela de ambientes

function removeEnvironmentsFancybox() {
    if (jQuery('.main-environments-content-internal-itens-item').length) {
        jQuery('body').off('click', '.main-environments-content-internal-itens-item a');
    }
}

if (jQuery('.main-environments-content-internal-itens-item').length) {
    jQuery(window).on('load pageshow', function () {
        removeEnvironmentsFancybox();

        setTimeout(removeEnvironmentsFancybox, 100);
        setTimeout(removeEnvironmentsFancybox, 500);
    });
}

// Modal single ambientes
if(jQuery('.main-single-environments-content-internal-itens-item').length) {
    jQuery(document).on('click', '.main-single-environments-content-internal-itens-item', function(){
        let id = jQuery(this).data('modal');

        jQuery('.environment-modal-body').html(
            jQuery('#' + id).html()
        );

        if(jQuery('.environment-modal-body .environment-modal-product').length){
            jQuery('.environment-modal').removeClass('without-products');
        }else{
            jQuery('.environment-modal').addClass('without-products');
        }
        jQuery('.environment-modal').addClass('active');
    });

    jQuery(document).on('click', '.environment-modal-close', function(){
        jQuery('.environment-modal').removeClass('active without-products');
    });

    jQuery(document).on('click', '.environment-modal', function(e){
        if(e.target === this){
            jQuery(this).removeClass('active without-products');
        }
    });

    jQuery(document).on('keydown', function(e){
        if((e.key === 'Escape' || e.key === 'Esc') && jQuery('.environment-modal').hasClass('active')){
            jQuery('.environment-modal').removeClass('active without-products');
        }
    });

// Ajustar tamanho do modal

    jQuery(document).on('click', '.main-single-environments-content-internal-itens-item', function(){
        let id = jQuery(this).data('modal');

        jQuery('.environment-modal-body').html(
            jQuery('#' + id).html()
        );

        let image = jQuery('.environment-modal-image img');

        image.on('load', function(){
            let height = jQuery(this).height();
            jQuery('.environment-modal-products').css({
                maxHeight: height - 100
            });
        });

        if(image[0].complete){
            image.trigger('load');
        }

        jQuery('.environment-modal').addClass('active');
    });
}

// Alterar classes das cores na single de produtos

if(jQuery('.main-produtos-interna-content-infos-colors-list').length) {
    jQuery(document).on('click', '.main-produtos-interna-content-infos-colors-list li', function(e){
        e.preventDefault();

        jQuery(this)
            .addClass('active')
            .siblings()
            .removeClass('active');
    });

    jQuery(document).on('click', '.main-produtos-interna-content-infos-lines-list li', function(e){
        e.preventDefault();

        jQuery(this)
            .addClass('active')
            .siblings()
            .removeClass('active');
    });
}

// Alterar o titulo das dimensões na single de produtos

if(jQuery('.main-produtos-interna-content-infos-dimensions-list').length) {
    jQuery('.main-produtos-interna-content-infos-dimensions-list .swiper-slide').on('click', function() {
        jQuery('.main-produtos-interna-content-infos-dimensions-list .swiper-slide').removeClass('active');
        jQuery(this).addClass('active');

        jQuery('.title-dimension-info').text(jQuery(this).find('.dimension-container').text());
    });
}

// Sessão de navegação single produtos

if(jQuery('.main-produtos-interna-content-tabs').length) {

    jQuery(document).on('click', '.main-produtos-interna-content-about-tabs button', function(e){
        e.preventDefault();

        var tab = jQuery(this).data('tab');

        jQuery('.main-produtos-interna-content-about-tabs button')
            .removeClass('active');

        jQuery(this).addClass('active');

        jQuery('.main-produtos-interna-content-tabs-item')
            .removeClass('active');

        jQuery('#tab-' + tab)
            .addClass('active');
    });

}

// Copiar link single blog

if (jQuery('.copy-link').length) {
    jQuery(document).on('click', '.copy-link', function (e) {
        e.preventDefault();

        const button = this;
        const link = jQuery(button).data('link');

        function showPopover() {
            let popover = button.querySelector('.copy-link-popover');

            if (!popover) {
                popover = document.createElement('span');
                popover.className = 'copy-link-popover';
                popover.textContent = 'Link copiado para a área de transferência';
                button.appendChild(popover);
            }

            popover.classList.add('show');

            clearTimeout(button._popoverTimeout);

            button._popoverTimeout = setTimeout(function () {
                popover.classList.remove('show');
            }, 2000);
        }

        navigator.clipboard.writeText(link).then(showPopover).catch(function () {
            const input = document.createElement('input');
            input.value = link;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);

            showPopover();
        });
    });
}

if (jQuery('.products-environment-filter').length) {

    const environmentFilter = jQuery('.products-environment-filter');
    const select = environmentFilter.find('.products-environment-select');
    const current = environmentFilter.find('.products-environment-select-current');

    current.on('click', function (e) {
        e.preventDefault();

        select.toggleClass('active');
    });

    environmentFilter.find('.products-environment-select-option').on('click', function () {

        const option = jQuery(this);

        if (option.is('a')) {
            return;
        }

        environmentFilter.find('.products-environment-select-option').removeClass('active');
        option.addClass('active');

        current.find('span').text(option.text().trim());

        select.removeClass('active');
    });

    jQuery(document).on('click', function (e) {

        if (!jQuery(e.target).closest('.products-environment-filter').length) {
            select.removeClass('active');
        }

    });

}

if (jQuery('.main-products-search').length) {
    jQuery('.main-products-search input[type="submit"]').on('click', function (e) {
        const form = jQuery(this).closest('.main-products-search');
        const input = form.find('input[type="text"]');

        if (!form.hasClass('active')) {
            e.preventDefault();

            form.addClass('active');

            setTimeout(function () {
                input.trigger('focus');
            }, 300);
        }
    });

    jQuery('.main-products-search .search-form-close').on('click', function () {
        const form = jQuery(this).closest('.main-products-search');

        form.removeClass('active');
        form.find('input[type="text"]').val('').blur();

    });
}

// Alterar direção do svg no filtro da página de produtos quando a listagem estiver ativa

if (jQuery(".filter-parent").length) {
    jQuery(".filter-parent").on("click", function (e) {
        e.preventDefault();

        const $parent = jQuery(this);
        const $list = $parent.next("ul");

        $parent.find("svg").toggleClass("is-active");
    });
}

// Corrigir infos de downloads de arquivos de produtos
if (jQuery('#products-select').length) {
    jQuery('#products-select').on('change', function () {
        const option = jQuery(this).find('option:selected');
        const fileSize = option.data('file-size') || '';
        const finishing = option.data('finishing') || '';

        jQuery('.main-downloads-projects-bar-result-infos .product-file-size').text(fileSize);
        jQuery('.main-downloads-projects-bar-result-infos .product-finishing').text(finishing);
    });
}

// Adicionar botão de limpeza de filtro e alterar botão de submit do form de downloads de sketchup
if (jQuery('#products-select').length) {

    const select = jQuery('#products-select');
    const arrow = jQuery('.products-select-submit');
    const clearForm = jQuery('.clear-products-select');

    select.on('change', function () {
        arrow.toggleClass('info-active', !!jQuery(this).val());
        clearForm.toggleClass('is-active', !!jQuery(this).val());
    });

    jQuery('.clear-products-select').on('click', function () {
        select.val('').trigger('change');
    });

}
// Filtros página de produtos

// if(jQuery('#filter-call')){
//     jQuery('#filter-call').on('click', function(e) {
        
//         if(!jQuery('#products-filter-sidebar').hasClass("active")) {
//             jQuery('#products-filter-sidebar').addClass("active");
//             jQuery('.main-produtos-content-center-list-content-data').removeClass("sidebar-off");
//         } else {
//             jQuery('#products-filter-sidebar').removeClass("active");
//             jQuery('.main-produtos-content-center-list-content-data').addClass("sidebar-off");
//         }
//         e.preventDefault();
//     });
// }
if(jQuery('#filter-call').length) {
    jQuery(document).on('click', '#filter-call', function(e) {
        e.preventDefault();

        jQuery('#products-filter-sidebar').toggleClass('active');
        jQuery('.main-produtos-content-center-list-content-data').toggleClass(
            'sidebar-off',
            !jQuery('#products-filter-sidebar').hasClass('active')
        );
    });
}
if(jQuery('#products-filter-sidebar').length) {
    document.addEventListener('DOMContentLoaded', function() {
        function verificarFiltros() {
        if (jQuery('.active-filter').length) {
            jQuery('#products-filter-sidebar').addClass('active');
            jQuery('.main-produtos-content-center-list-content-data').removeClass('sidebar-off');
        }
        // } else {
        //     jQuery('#products-filter-sidebar').removeClass('active');
        //     jQuery('.main-produtos-content-center-list-content-data').addClass('sidebar-off');
        // }
    }

    verificarFiltros();

    const observer = new MutationObserver(function () {
        verificarFiltros();
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    });
}

if (jQuery('.main-produtos-content-center-filter-order-list').length) {

    jQuery(document).on('click', function(e) {

        if (
            jQuery('.main-produtos-content-center-filter-order-list').hasClass('is-active') &&
            !jQuery(e.target).closest('.main-produtos-content-center-filter-order-list').length &&
            !jQuery(e.target).closest('.main-produtos-content-center-filter-order-call').length
        ) {
            jQuery('.main-produtos-content-center-filter-order-list').removeClass('is-active');
        }

    });

}


// Vídeo Lançamentos Home

jQuery(function () {

    jQuery('.main-home-combina-right iframe').each(function () {
        const iframe = jQuery(this);

        const src = iframe.attr('src');
        iframe.attr('data-src', src);
        iframe.attr('src', '');
    });

    jQuery('.main-home-combina-right-video').on('click', function (e) {
        e.preventDefault();

        const container = jQuery(this).closest('.main-home-combina-right');
        const iframe = container.find('iframe');

        let src = iframe.data('src');

        src += (src.indexOf('?') !== -1 ? '&' : '?') + 'autoplay=1';

        iframe.attr('src', src);

        container.addClass('playing');
    });

});


jQuery(function () {

    jQuery('.main-collection-campaign-right iframe').each(function () {
        const iframe = jQuery(this);

        const src = iframe.attr('src');
        iframe.attr('data-src', src);
        iframe.attr('src', '');
    });

    jQuery('.main-collection-campaign-right-video').on('click', function (e) {
        e.preventDefault();

        const container = jQuery(this).closest('.main-collection-campaign-right');
        const iframe = container.find('iframe');

        let src = iframe.data('src');

        src += (src.indexOf('?') !== -1 ? '&' : '?') + 'autoplay=1';

        iframe.attr('src', src);

        container.addClass('playing');
    });

});

// Collapse politica de qualidade
if (jQuery('.main-quality-content').length) {
    jQuery('.main-quality-content .more').on('click', function (e) {
        e.preventDefault();

        jQuery(this)
            .closest('.main-quality-content')
            .toggleClass('active');
    });
}


// document.addEventListener('DOMContentLoaded', function() {

// if(jQuery('.active-filter')) {
//         jQuery('#products-filter-sidebar').addClass("active");
//     }
// });

document.addEventListener('DOMContentLoaded', function() {
    jQuery('#form-product-environments select[name="products"]').select2( { 
        language: {
            noResults:function() {
                return jQuery("#products_environment").data("no-results"); 
            },
            searching:function() {
                return jQuery("#products_environment").data("searching") + '...';
            },
            inputTooShort:function() {
                return jQuery("#products_environment").data("inputshort");
            },
            loadMore:function() {
                return jQuery("#products_environment").data("more") + '...';
            }
        },
        ajax: {
            url:ajax_url,
            dataType:"json",
            data:function(e) {
                return {
                    search:e.term,
                    action:"get_products"
                }
            }
        },
        minimumInputLength:3,
        placeholder:"Procure por um produto"
    })

    jQuery('body').on('change','#products_environment',function(){
        var valor = jQuery(this).val();
        var nome  = jQuery('#products_environment option:selected').text();
        var lang  = jQuery('body').attr('data-lang');
        if(valor !== '#'){
            if(valor){
                var product = valor.split('|');
                jQuery(".loader").addClass("active");
                jQuery.ajax({
                    type: "POST",
                    data: { action: 'get_environments_by_product', product_environment: product[0], lang: lang },
                    url: ajax_url,
                    success: function (result) {
                        console.log(result);
                        jQuery(".main-environments-content-internal").addClass('d-none');
                        jQuery(".main-environments-content-external").addClass('d-none');
                        jQuery(".content-search-found h2 strong").html(nome);
                        jQuery(".content-search-found").removeClass('d-none');
                        jQuery(".itens-search-found").html(result);
                        jQuery(".loader").removeClass("active");
                    }
                });
            }else{ 
                jQuery(".main-environments-content-internal").removeClass('d-none');
                jQuery(".main-environments-content-external").removeClass('d-none');
                jQuery(".content-search-found h2 strong").html('');
                jQuery(".content-search-found").addClass('d-none');
                jQuery(".itens-search-found").html('');
            }
        } 

    })

    jQuery('body').on('click','#allEnvironments',function(){
        jQuery(".loader").addClass("active");
        setTimeout(function(){
            jQuery(".main-environments-content-internal").removeClass('d-none');
            jQuery(".main-environments-content-external").removeClass('d-none');
            jQuery(".content-search-found h2 strong").html('');
            jQuery(".content-search-found").addClass('d-none');
            jQuery(".itens-search-found").html('');
            jQuery(".loader").removeClass("active");
            jQuery('#form-product-environments select[name="products"]').select2("val", "#");
        }, 2000);
    })

})

function registrarDownload(tipo) {
    var xhr = new XMLHttpRequest();
    xhr.open('POST', ajax_url, true); 
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

    xhr.onload = function() {
        if (xhr.status === 200) {
            //window.location.href = xhr.responseText; // Redireciona para o link do arquivo após registrar
            console.log(xhr.responseText);
        }
    };

    xhr.send('action=registrar_download&tipo=' + tipo);
}

document.querySelectorAll('.infos-gallery-paginado').forEach(link => {
  link.addEventListener('click', function (e) {
    e.preventDefault();
    const src = this.getAttribute('data-src');
    if (src) {
      Fancybox.show([{ src: src, type: "image" }]);
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const links = document.querySelectorAll(".navScrollSimple");

  if (links.length) {
    links.forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();

        const href = this.getAttribute("href");
        const distanciaTopo = this.getAttribute("data-top") 
          ? parseInt(this.getAttribute("data-top"), 10) 
          : 180;

        const target = document.querySelector(href);
        if (target) {
          const top = target.offsetTop - distanciaTopo;

          window.scrollTo({
            top: top,
            behavior: "smooth"
          });
        }
      });
    });
  }
});

// Customização da lista de locais

if (jQuery('.products-order-dropdown').length) {

    jQuery('.products-order-dropdown').each(function() {

        const dropdown = jQuery(this);
        const select = dropdown.siblings('select');
        const list = dropdown.find('.products-order-dropdown-list');
        const current = dropdown.find('.products-order-dropdown-current span');

        select.find('option').each(function() {
            const option = jQuery(this);

            list.append(
                '<a href="#" data-value="' + option.val() + '">' + option.text() + '</a>'
            );
        });

        list.find('a').first().addClass('filter-active');

        dropdown.find('.products-order-dropdown-current').on('click', function(e) {
            e.preventDefault();

            dropdown.toggleClass('active');
        });

        list.on('click', 'a', function(e) {
            e.preventDefault();

            const option = jQuery(this);
            const value = option.data('value');

            current.text(option.text());

            list.find('a').removeClass('filter-active');
            option.addClass('filter-active');

            select.val(value).trigger('change');

            dropdown.removeClass('active');
        });

    });

    jQuery(document).on('click', function(e) {
        if (!jQuery(e.target).closest('.products-order-dropdown').length) {
            jQuery('.products-order-dropdown').removeClass('active');
        }
    });

}

if (jQuery('#form-store').length) {
    const originalAddClass = jQuery.fn.addClass;

    jQuery.fn.addClass = function(className) {
        if (this.is('body > .loader') && typeof className === 'string' && className.split(/\s+/).includes('active') && jQuery('#form-store input[name="store"]').is(':focus')) {
            jQuery('.main-where-find-stores-content-results-list-items').addClass('load');
            return this;
        }

        return originalAddClass.apply(this, arguments);
    };
}

if (jQuery('#form-store input[name="store"]').length) {
    let timer;
    const loader = document.querySelector('body > .loader');
    const results = jQuery('.main-where-find-stores-content-results-list-items');

    jQuery('#form-store input[name="store"]').on('input', function() {
        clearTimeout(timer);
        loader.classList.remove('active');
        results.removeClass('load');

        timer = setTimeout(function() {
            results.addClass('load');
        }, 1000);
    });

    jQuery(document).ajaxComplete(function() {
        clearTimeout(timer);
        loader.classList.remove('active');
        results.removeClass('load');
    });
}

jQuery(document).ready(function() {
    const results = jQuery('.main-where-find-stores-content-results-list-items');
    const headerLoader = jQuery('body > .loader');

    if (!results.length) return;

    jQuery(document).ajaxSend(function() {
        if (headerLoader.hasClass('active')) {
            headerLoader.removeClass('active');
            results.addClass('load');
        }
    });

    jQuery(document).ajaxComplete(function() {
        results.removeClass('load');
        headerLoader.removeClass('active');
    });
});